// extracted by mini-css-extract-plugin
export var button = "_j9-2";
export var card = "_j9-0";
export var closeButtonContainer = "_j9-3";
export var iconContainer = "_j9-1";